// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + {"240":"news-center","440":"news-detail","462":"feature-intro","467":"download","492":"download-guide","804":"company-profile","962":"home"}[chunkId] + "." + {"240":"2e619bfb","440":"afb83366","462":"1c58f698","467":"f1e94423","492":"0d54ce32","804":"5e1e1881","962":"18764bac"}[chunkId] + ".js";
};